export default {
    data() {
        return {
            showMobileDrawer: null,
            stickyWidth: null,
            isIntersecting: false
        }
    },
    computed: {
        getMobileStatus() {
            return this.$store.getters.getIsMobile
        },
        getDrawerStatus() {
            return this.showMobileDrawer
        },
        getClassNames () {
            if (this.getMobileStatus) {
                return "col-md-12 px-md-5 py-4 bg-white"
            }
            return "col-md-8 px-md-5 py-4 bg-white"
        }
    },
    beforeDestroy() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.onResize, {passive: true})
        }
    },
    mounted() {
        this.onResize()
        window.addEventListener('resize', this.onResize, {passive: true})
    },
    methods: {
        onResize() {
            if ( window.innerWidth > 913 ) {
                if (  this.stickyWidth  !==  this.$refs.sticky__wrapper.clientWidth ) {
                    this.stickyWidth = this.$refs.sticky__wrapper.clientWidth
                }
            }
        },
        onIntersect (entries, observer) {
            if (this.$refs.article && this.$refs.stickyContent) {
                  if( this.$refs.article.clientHeight > this.$refs.stickyContent.clientHeight) {
                    // if statues page
                    if (this.$refs.sammioArticle !== undefined) {
                       const elemH = this.$refs.sammioArticle.getBoundingClientRect().height
                        // If article is higher than viewport, allow sticky functionalities
                        if (elemH > window.innerHeight) {
                            this.onResize()
                            this.isIntersecting = entries[0].intersectionRatio < 0.2
                        }
                    } else {
                        this.onResize()
                        this.isIntersecting = entries[0].intersectionRatio < 0.2
                    }
                }
            }
        },
        setDrawerStatus(value) {
            this.showMobileDrawer = value
        },
        isOutOfViewPort(elem) {

            // Get element's bounding
            const bounding = elem.getBoundingClientRect();

            // Check if it's out of the viewport on each side
            let out = {};
            out.top = bounding.top < 0;
            out.left = bounding.left < 0;
            out.bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
            out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
            out.any = out.top || out.left || out.bottom || out.right;
            out.all = out.top && out.left && out.bottom && out.right;

            return out;
        }
    }
}